import React from 'react';
import type { ReactElement } from 'react';
import type { ThemeState } from '@atlaskit/tokens';
import { useIsMobileApp, mobileAppTheme } from '@confluence/mobile-app-detection';

import { useInitializeTheme } from './useInitializeTheme';

export const ThemeContainer = ({ children }: { children: ReactElement }) => {
	const { isMobileApp } = useIsMobileApp();

	const initialTheme: Partial<ThemeState> | undefined = isMobileApp ? mobileAppTheme : undefined;

	const isInitialized: boolean = useInitializeTheme(initialTheme);

	if (!isInitialized) {
		return <></>;
	}
	return <>{children}</>;
};
